module.exports = __webpack_public_path__ + "static/media/newyear.53e2da06.jpg";